document.documentElement.classList.remove('no-js');

const toggle = document.querySelector('.nav-toggle');
const nav = document.querySelector('.site-nav');
if (toggle && nav) {
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });
}

const mainImage = document.querySelector('.product-gallery__main img');
document.querySelectorAll('[data-product-image]').forEach((button) => {
  button.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.src = button.dataset.productImage;
    document.querySelectorAll('[data-product-image]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  });
});

const quantity = document.querySelector('#Quantity');
document.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
  if (!quantity) return;
  quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
});
document.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
  if (!quantity) return;
  quantity.value = String(Number(quantity.value || 1) + 1);
});
